let language = {
    CHECKOUT_SHIPPING_TITLE: "收件地址",
    CHECKOUT_SHIPPING_EMPTY: "没有送货地址。请先添加送货地址！",
    CHECKOUT_SHIPPING_BILLING: "账单地址",
    CHECKOUT_SHIPPING_SELECT: "选择地址",
    CHECKOUT_SHIPPING_SAME_ADDRESS: "寄付账单地址与送货地址相同",
    CHECKOUT_SHIPPING_BILLING_EMPTY: "没有账单地址。请先添加账单地址！",
    CHECKOUT_SHIPPING_METHOD: "邮寄方式",
    CHECKOUT_SHIPPING_ISSUE_LOADING_TITLE: "配送方式加载问题",
    CHECKOUT_SHIPPING_ISSUE_LOADING_CONTENT:"加载配送方法时发生问题。请刷新页面再试一次。如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}.",
    CHECKOUT_SHIPPING_ISSUE_SHIPPING_METHOD_CONTENT: "获取订单配送方式时出错，您可以点击\"{{retryBtn}}\"立即获取，或者点击\"{{cancelBtn}}\"关闭提示。",
    CHECKOUT_SHIPPING_METHOD_ISSUE_TITLE: "配送方式问题",
    CHECKOUT_SHIPPING_METHOD_ISSUE_BLACKLIST_ADDRESS: "此订单的送货地址不在 {{appName}} 的服务范围之内。请更改地址以继续此订单。{{regions}}"
}


export { language }